import Vue from 'vue'
import Vuex from 'vuex'
import storeConfig from '@/store'

Vue.use(Vuex)

const store = new Vuex.Store({
	...storeConfig,
	strict: process.env.NODE_ENV !== 'production'
})

export default store
